export { default } from '@material-ui/core/CircularProgress';
